"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurningBreathAbilityHandler = exports.BurningBreathActorAbilityFactory = exports.BurningBreathAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class BurningBreathAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BurningBreath;
        this.__typeName = "BurningBreath";
    }
}
exports.BurningBreathAbilityArgs = BurningBreathAbilityArgs;
let BurningBreathActorAbilityFactory = class BurningBreathActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BurningBreath", "OneEnemies", 0);
    }
};
BurningBreathActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BurningBreath")
], BurningBreathActorAbilityFactory);
exports.BurningBreathActorAbilityFactory = BurningBreathActorAbilityFactory;
let BurningBreathAbilityHandler = class BurningBreathAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            sequence,
            targets: [
                {
                    targetId,
                    damages: [
                        AbilityDamage_1.AbilityDamage.Focus("Fire", 80)
                    ],
                    effects: [
                        {
                            targetId,
                            duration: Duration_1.Duration.Turns(5),
                            effect: new core_1.BurningEffectArgs("Focus", 10),
                        }
                    ]
                }
            ]
        });
    }
};
BurningBreathAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BurningBreath)
], BurningBreathAbilityHandler);
exports.BurningBreathAbilityHandler = BurningBreathAbilityHandler;
